(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Script para atualizar preços quando botões de cor são clicados
  // Funciona em conjunto com product-card.js
  (function() {
    function initPriceUpdate() {
      // Encontrar todos os product-cards na página
      const productCards = document.querySelectorAll('.product-card');
      
      productCards.forEach(card => {
        // Verificar se já foi inicializado
        if (card.dataset.priceUpdateInitialized) return;
        card.dataset.priceUpdateInitialized = 'true';
        
        const variantPicker = card.querySelector('.product-card__colors');
        if (!variantPicker) return;
        
        // Adicionar listener para todos os botões de cor dentro deste card
        const colorButtons = variantPicker.querySelectorAll('.product-card__color');
        
        colorButtons.forEach(button => {
          button.addEventListener('click', function(e) {
            // Pequeno delay para garantir que o product-card.js também execute
            setTimeout(function() {
              // Encontrar o card pai
              const productCard = button.closest('.product-card');
              if (!productCard) return;
              
              // Obter preços dos data attributes do botão clicado
              const price = button.dataset.price;
              const comparePrice = button.dataset.comparePrice;
              
              if (!price) return;
              
              // Encontrar elementos de preço dentro deste card específico
              const priceContainer = productCard.querySelector('.product-card__price');
              if (!priceContainer) return;
              
              const priceElement = priceContainer.querySelector('.product-card__price--current');
              const comparePriceElement = priceContainer.querySelector('.product-card__price--compare');
              
              if (!priceElement) return;
              
              // Converter de centavos para formato monetário
              const priceNum = parseFloat(price);
              const comparePriceNum = parseFloat(comparePrice) || 0;
              
              // Lógica: Se price > compare_at_price: mostrar price riscado e compare_at_price normal
              // Se compare_at_price >= price: mostrar apenas price normal
              if (priceNum > comparePriceNum && comparePriceNum > 0) {
                // price é maior: mostrar price riscado (--compare) e compare_at_price normal (--current)
                const priceInReais = priceNum / 100;
                const comparePriceInReais = comparePriceNum / 100;
                
                const formattedPrice = new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(priceInReais);
                
                const formattedComparePrice = new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(comparePriceInReais);
                
                // Mostrar price riscado no --compare
                if (comparePriceElement) {
                  comparePriceElement.textContent = formattedPrice;
                  comparePriceElement.dataset.comparePrice = price;
                  comparePriceElement.style.display = '';
                }
                
                // Mostrar compare_at_price normal no --current
                priceElement.textContent = formattedComparePrice;
                priceElement.dataset.price = comparePrice;
              } else {
                // compare_at_price >= price: mostrar apenas price normal
                const priceInReais = priceNum / 100;
                const formattedPrice = new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(priceInReais);
                
                // Ocultar --compare
                if (comparePriceElement) {
                  comparePriceElement.style.display = 'none';
                }
                
                // Mostrar price normal no --current
                priceElement.textContent = formattedPrice;
                priceElement.dataset.price = price;
              }
            }, 10);
          });
        });
      });
    }
    
    // Inicializar quando o DOM estiver pronto
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPriceUpdate);
    } else {
      initPriceUpdate();
    }
    
    // Re-inicializar quando novos cards são adicionados dinamicamente
    const observer = new MutationObserver(function(mutations) {
      initPriceUpdate();
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
